/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightValue: NonNullable<unknown>, metric: NonNullable<unknown> }} Chain_Page_Compare_Validators_Or_Miners_No_LeftInputs */



/**
* | output |
* | --- |
* | "{leftChain} has no data, while {rightChain} has {rightValue} {metric}" |
*
* @param {Chain_Page_Compare_Validators_Or_Miners_No_LeftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_validators_or_miners_no_left = /** @type {((inputs: Chain_Page_Compare_Validators_Or_Miners_No_LeftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Validators_Or_Miners_No_LeftInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has no data, while ${i?.rightChain} has ${i?.rightValue} ${i?.metric}`)
});